import { v4 as uuidv4 } from 'uuid';

import { dispatchPromise, fetchResources } from './action-helpers';

import { Favorite } from 'types';

const DEFAULT_FAVORITE_PROPS = {
    id: null,
    created_at: null,
    order: Number.POSITIVE_INFINITY
};

export const createFavorite = (favoriteProps: Partial<Favorite>) => {
    return dispatchPromise({
        type: 'FAVORITE_CREATE_REQUESTED',
        payload: {
            favorite: Object.assign({}, DEFAULT_FAVORITE_PROPS, favoriteProps, {
                id: uuidv4(),
                created_at: new Date(),
            })
        }
    });
}

export const fetchFavorites = (all?: boolean) => fetchResources('FAVORITES_FETCH_REQUESTED', {}, all);

export const updateFavorite = (favoriteId: string, favoriteProps: Partial<Favorite>, preventSave?: boolean) => {
    return dispatchPromise({
        type: 'FAVORITE_UPDATE_REQUESTED',
        preventSave,
        payload: {
            favoriteId,
            favoriteProps
        }
    });
}

export const removeFavorite = (favoriteId: string) => {
    return dispatchPromise({
        type: 'FAVORITE_REMOVE_REQUESTED',
        payload: {
            favoriteId
        }
    });
}
